import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/contact.svg'


const _hoisted_1 = { class: "aside-contact" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "contact image"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "aside-contact-text text-300 opacity-80" }, [
  /*#__PURE__*/_createTextVNode(" Having Trouble with the Portal. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Feel free to reach out to us. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openModal('contact', 'Contact Us', 'plan-upload plan-card-info plan-profile-update plan-tables pension-credits')), ["prevent"])),
      class: "btn btn-secondary btn-contact plan-modal"
    }, "Contact Us")
  ]))
}